import { useEffect, useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';

import { useDebounce } from '../hooks';
import { PatrimoniosService } from '../services/api/cadastros/PatrimoniosService';
import { useField } from '@unform/core';


type TAutoCompleteOption = {
  idpatrimonio: string;
  label: string;
}

interface IAutoCompleteFazendaProps {
  isExternalLoading?: boolean;
  idpatrimonios?: (novoTextoselect: string | undefined) => void;
  descricao?: (novoTextoselect: string | undefined) => void;
}
export const AutoCompletePatrimonio: React.FC<IAutoCompleteFazendaProps> = ({ isExternalLoading = false, idpatrimonios, descricao }) => {
  const { fieldName, registerField, defaultValue, error, clearError } = useField('idpatrimonio');
  const { debounce } = useDebounce();
  const [selectedId, setSelectedId] = useState<string | undefined>(defaultValue);

  const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [busca, setBusca] = useState('');

  useEffect(() => {
    registerField({
      name: fieldName,
      getValue: () => selectedId,
      setValue: (_, newSelectedId) => setSelectedId(newSelectedId),
    });
  }, [registerField, fieldName, selectedId]);

  useEffect(() => {  
    setIsLoading(true);
    debounce(() => {  
      PatrimoniosService.getAlllist(selectedId, busca)
        .then((result) => {
          setIsLoading(false);

          if (result instanceof Error) {
            // alert(result.message);
          } else {
            setOpcoes(result.data.map(patrimonio => ({ idpatrimonio: patrimonio.idpatrimonio, label: patrimonio.numero + ' - ' + patrimonio.descricao })));
          }
        });
    });
  }, [busca, selectedId]);

  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;

    const selectedOption = opcoes.find(opcao => opcao.idpatrimonio === selectedId);
    if (!selectedOption) return null;

    return selectedOption;
  }, [selectedId, opcoes]);


  return (
    <Autocomplete
      openText='Abrir'
      closeText='Fechar'
      noOptionsText='Sem opções'
      loadingText='Carregando...'

      disablePortal

      options={opcoes}
      loading={isLoading}
      disabled={isExternalLoading}
      value={autoCompleteSelectedOption}
      onInputChange={(_, newValue) => setBusca(newValue)}
      onChange={(_, newValue) => { setSelectedId(newValue?.idpatrimonio); descricao?.(newValue?.label); idpatrimonios?.(newValue?.idpatrimonio); 
        setBusca(''); clearError();}}
      popupIcon={(isLoading) ? <CircularProgress size={28} /> : undefined}
      renderInput={(params) => (
        <TextField
          {...params}
          size='small'
          label="Patrimonio"
          error={!!error}  
          helperText={error}
        />
      )}
    />
  );
};